import type { MisconceptionDefinition } from './types';

/** TIJD — Tijd misconcepties. */
export const TIJD_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'tijd.speed-formula-confused',
  label: 'Snelheidsformule verward',
  module: 'Tijd',
  description: 'Leerling gebruikt de verkeerde bewerking (bijv. vermenigvuldigen in plaats van delen) bij de AST-driehoek.',
  typicalFamilies: ['TIJD-SNELHEID', 'TIJD-AFSTAND', 'TIJD-GEMIDDELDE']
}, {
  id: 'tijd.minutes-to-hours-error',
  label: 'Minuten naar uren fout',
  module: 'Tijd',
  description: 'Leerling rekent minuten verkeerd om naar decimale uren (bijv. 15 min = 0,15 uur in plaats van 0,25 uur).',
  typicalFamilies: ['TIJD-SNELHEID', 'TIJD-AFSTAND', 'TIJD-GEMIDDELDE']
}, {
  id: 'tijd.timezone-direction-confused',
  label: 'Tijdzone richting verward',
  module: 'Tijd',
  description: 'Leerling telt uren op in plaats van af te trekken bij tijdzones, of andersom.',
  typicalFamilies: ['TIJD-TIJDZONES']
}, {
  id: 'tijd.timezone-midnight-error',
  label: 'Tijdzone over middernacht',
  module: 'Tijd',
  description: 'Leerling houdt geen rekening met de 24-uurs grens bij tijdzones.',
  typicalFamilies: ['TIJD-TIJDZONES']
}, {
  id: 'tijd.timezone-flight-error',
  label: 'Tijdverschil vergeten bij vlucht',
  module: 'Tijd',
  description: 'Leerling vergeet het tijdverschil op te tellen of af te trekken bij het berekenen van de aankomsttijd na een vlucht.',
  typicalFamilies: ['TIJD-TIJDZONES']
}];